module.exports = __webpack_public_path__ + "static/media/playalong-kickoff.fa9d24f0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/preview/playalong-kickoff.jpg
// module id = ./src/assets/images/preview/playalong-kickoff.jpg
// module chunks = 0